import $, { each } from "jquery";
import { debounce } from "../utils/utils";

export default class CarCostCalulator extends HTMLDivElement {

    defaultState = 'initialized';

    additionalFuel = false;

    formFieldSelector = ".form-control, :radio, :checkbox";

    constructor() {
        super();
    }

    log(...params) {
        console.log("CarCost: ", ...params);
    }

    connectedCallback() {

        this.dataset.state = this.defaultState;

        this.log("connectedCallback", this.nextButtons, this.previousButtons, this.submitButtons);

        var calculator = this;

        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            return false;
        });

        if (this.nextButtons) {
            this.nextButtons.forEach(element => { element.addEventListener("click", (e) => { this.nextStep(); }) });
        }

        if (this.previousButtons) {
            this.previousButtons.forEach(element => { element.addEventListener("click", (e) => { this.previousStep(); }) });
        }

        if (this.submitButtons) {
            this.submitButtons.forEach(element => { element.addEventListener("click", (e) => { this.submitForm(); }) });
        }

        $(this).on("click", ".add-btn, .remove-btn", this.toggleAdditionalFuel);

        $(this).on("change", "input[type=radio][name=TypeOfCar]", function () {
            $("#TypeOfCarError").hide();
        });

        $(this).on("change", "input[type=radio][name=TypeOfMaintenance]", function () {
            $("#TypeOfMaintenanceError").hide();
        });

        $(this).on("change", "input[type=radio][name=Depreciation]", function () {
            $("#DepreciationError").hide();
        });

        $(this).on("change", ".fuel-dropdown", function () {
            var label = $(this).closest(".row").find(".fuel-price-label");
            var labelText = calculator.changePriceLabel($(this));
            label.text(labelText);
        });

        $(this).on("change", "#Form_MalusTax", function () {
            $("[data-valmsg-for='Form.MalusTax']").hide();
        });

        $(this).on("input", "#Form_YearsSinceManufactured", debounce(calculator.updateChart,
            250,
            calculator));

        $(this).on("input", "#Form_YearsToKeep", debounce(calculator.updateChart,
            250,
            calculator));

        $(this).on("input", "#Form_PurchasePrice", debounce(calculator.updateChart,
            250,
            calculator));

        setTimeout(this.updateChart, 500);

        this.shareResultEnable();

        history.pushState({ step: 1 }, "Step " + 1);
        window.addEventListener("popstate", function (event) {
            var step = parseInt(document.getElementById("Step").value);
            calculator.changeActiveStep(step, event.state.step);
        });

    }

    disconnectedCallback() {

    }

    get nextButtons() {
        return this.querySelectorAll("button[data-carcost-button='next']");
    }

    get previousButtons() {
        return this.querySelectorAll("button[data-carcost-button='previous']");
    }

    get submitButtons() {
        return this.querySelectorAll("input[data-carcost-button='submit']");
    }

    get form() {
        return this.querySelector('form');
    }

    get chartElement() {
        return this.querySelector("[is='car-cost-chart']");
    }

    get purchasePriceInput() {
        return document.querySelector("#Form_PurchasePrice");
    }

    get yearsSinceManufacturedInput() {
        return document.querySelector("#Form_YearsSinceManufactured");
    }

    get yearsToKeepInput() {
        return document.querySelector("#Form_YearsToKeep");
    }

    get resultYearlyCostElements() {
        return document.querySelectorAll("[data-carcost='result-yearly']") || new NodeList();
    }

    get resultMonthlyCostElements() {
        return document.querySelectorAll("[data-carcost='result-monthly']") || new NodeList();
    }

    get resultMileageCostElements() {
        return document.querySelectorAll("[data-carcost='result-mileage']") || new NodeList();
    }

    get step() {
        return Number(this.querySelector("#Step").value);
    }

    set step(value) {
        this.querySelector("#Step").value = value;
    }

    changePriceLabel(dropdown) {
        switch (dropdown.val()) {
            case "Biogas":
                return "Pris (kg)";
            case "El":
                return "Pris (kWh)";
            default:
                return "Pris (kr/l)";
        }
    }

    showHiddenInputs() {
        $(".hidden-inputs-unknown-car").toggle("fast", function () {
        });
    }

    toggleAdditionalFuel = (e) => {

        $(".additional-fuel").toggle("fast", () => {
            this.additionalFuel = !this.additionalFuel;
        });

        $(".add-btn").toggle();

        if (!this.additionalFuel) {

            if (e.target.closest("#update")) {
                $("#AdditionalFuelPrice-Result").val("");
                $("#AdditionalFuelPercentage-Result").val("");
                $("#AdditionalFuel-Result").val("Bensin");

                this.updateForm();
            }

            $("#AdditionalFuelPrice").val("");
            $("#AdditionalFuelPercentage").val("");
            $("#AdditionalFuel").val("Bensin");

            $("[name=\"Form.AdditionalFuelPercentage\"]").closest("[is=\"radio-button-list\"]").each((index, el) => el.reset());

        }
    }

    nextStep() {
        var step = parseInt($("#Step").val());
        this.log("NextStep", step);
        if (this.validateStep(step)) {
            this.log("NextStep", step, "valid");
            this.changeActiveStep(step, step + 1, true);
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
    }

    previousStep() {
        var step = parseInt($("#Step").val() - 1);
        this.changeActiveStep(step + 1, step, true);
    }

    changeActiveStep(prevStep, newStep, updateHistory) {
        $("#step" + prevStep).hide();
        $("#step" + newStep).show();
        $("#Step").val(newStep);
        this.log("ChangeStep", prevStep, newStep);

        if (prevStep > newStep) {
            $(".wizard-steps > div").eq(prevStep - 1).removeClass("wizard-step-active");

        } else {
            $(".wizard-steps > div").eq(newStep - 1).addClass("wizard-step-active");
        }

        if (updateHistory) {
            history.pushState({ step: newStep }, "Step " + newStep);
        }

        // Google tag manager
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'bkk-step-change',
                'attributes': {
                    'stepNumber': newStep,
                    'stepTitle': $("#step" + newStep).find("h1").text()
                }
            });
        }
    }

    submitForm = () => {
        this.log("SubmitForm");
        var step = parseInt($("#Step").val());
        const calculator = this;
        this.log($(this.form).attr("action"), $(this.form).serialize());
        if (this.validateStep(step)) {
            this.log("SubmitForm", "Valid");
            $(".form-control.number").each(function () {
                $(this).val(calculator.replaceDotWithComma($(this).val()));
            });
            $.ajax({
                type: 'POST',
                url: $(this.form).attr("action"),
                data: $(this.form).serialize(),
                success: (response) => {
                    this.log("SubmitForm", "PostSuccess");
                    this.changeActiveStep(step, step + 1, true);
                    $("#result").html(response);
                    this.initResult();
                },
                complete: () => {
                    this.log("SubmitForm", "PostComplete");
                    $.validator.unobtrusive.parse("#update");
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }
            });
        }
    }

    initResult = () => {

        const calculator = this;

        $("#ApproveShare").on("change", this.shareResultEnable);

        $("#share-result-btn").on("click", this.shareResult);

        $(".form-control.number").each(function () {
            $(this).val(calculator.replaceDotWithComma($(this).val()));
        });

        $(".fuel-dropdown").each(function () {
            var label = $(this).closest(".wizard-panel").find(".fuel-price-label");
            var labelText = calculator.changePriceLabel($(this));
            label.text(labelText);
        });

        $(".fuel-dropdown").on("change", function () {
            var label = $(this).closest(".wizard-panel").find(".fuel-price-label");
            var labelText = calculator.changePriceLabel($(this));
            label.text(labelText);
        });

        // Reduce fuel consumption
        $("#FuelConsumptionReducedWithFivePercent").change(function () {
            calculator.log("FuelConsumptionReducedWithFivePercent");
            if ($("#FuelConsumptionReducedWithFivePercent").is(":checked")) {
                $('#FuelConsumptionReducedWithTenPercent').prop('checked', false);
            }
        });

        $("#FuelConsumptionReducedWithTenPercent").change(function () {
            calculator.log("FuelConsumptionReducedWithTenPercent");
            if ($("#FuelConsumptionReducedWithTenPercent").is(":checked")) {
                $('#FuelConsumptionReducedWithFivePercent').prop('checked', false);
            }
        });

        $("#update").on("input change", "input[type=range]", function () {
            $('.percent-range').text($(this).val());
            $(this).attr("aria-valuenow", $(this).val());
        })
            .on("change input", "input:not(#shareEmail)", debounce(function () {
                calculator.log("update input");
                if ($(this).attr('id') !== "ShareEmail") {
                    calculator.updateForm();
                }
            }, 250));
    }

    // Enable share result
    shareResultEnable = () => {
        this.log("shareResultEnable");
        if ($('#ApproveShare').is(':checked')) {
            $('#share-result-btn').prop('disabled', false);
        }
        else {
            $('#share-result-btn').prop('disabled', true);
        }
    }

    // Share result through email
    shareResult = () => {
        var email = $("#ShareEmail").val();
        var data = $("#result form").serialize();
        this.log("ShareResult", email, data, this.dataset.carcostShareurl);
        $("#shareEmailError").hide();
        if (this.validateEmail(email)) {
            $.ajax({
                type: 'POST',
                url: '/umbraco/surface/CarCostSurface/ShareResult', //this.dataset.carcostShareurl,
                data: $("#result form").serialize(),
                success: function (response) {
                    if (response.success) {
                        // Add message that the mail was sent
                        $("#shareResultMessage").text("Ditt resultat har skickats till " + email + ".");
                        $("#shareResultMessage").addClass("success");
                        $("#shareResultMessage").show();
                    } else {
                        // Add message that something went wrong
                        $("#shareResultMessage").html("N&#229;got gick fel n&#228;r resultatet skulle skickas. F&#246;rs&#246;k igen senare.");
                        $("#shareResultMessage").addClass("fail");
                        $("#shareResultMessage").show();
                    }
                }
            });
        } else {
            $("#shareEmailError").show();
        }
    }

    validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    validateStep(step) {
        this.log("ValidateStep", step);

        return $(this.formFieldSelector).filter(":visible").valid();
    }

    replaceDotWithComma(value) {
        return value.toString().replace(".", ",");
    }

    updateChart = () => {

        const purchasePrice = Number(this.purchasePriceInput.value);
        const yearsSinceManufactured = Number(this.yearsSinceManufacturedInput.value);
        const yearsToKeep = Number(this.yearsToKeepInput.value);

        if (purchasePrice >= 1000 &&
            yearsSinceManufactured >= 0 &&
            yearsToKeep >= 1) {

            if (typeof this.chartElement.update === 'function') {
                this.chartElement.update(purchasePrice, yearsSinceManufactured, yearsToKeep);
            }
        }

    }

    updateForm = () => {
        const calculator = this;
        $.ajax({
            type: 'POST',
            url: $("#update").attr("action"),
            data: $("#update").serialize(),
            success: function (response) {
                calculator.log("UpdateForm success", response);
                calculator.updateCosts(response);
            }
        });
    }

    updateCosts = (response) => {
        this.log("UpdateCosts", response);
        this.resultMileageCostElements.forEach(el => el.innerText = response.mileageCost);
        this.resultMonthlyCostElements.forEach(el => el.innerText = response.costPerMonth);
        this.resultYearlyCostElements.forEach(el => el.innerText = response.costPerYear);

        // Hidden values
        $("#Result_MileageCost").val(response.mileageCost);
        $("#Result_CostPerMonth").val(response.costPerMonth);
        $("#Result_CostPerYear").val(response.costPerYear);
    }

}

customElements.define('car-cost-calculator', CarCostCalulator, { extends: 'div' });